import React, { useEffect, useState } from 'react';
import { authService } from '../../services/authService';
import CompanyNav from '../../components/CompanyNav';
import CompanyBottomNavigation from '../../components/CompanyBottomNavigation';
import Loader from '../../components/Loader';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const EditUserProfile = () => {
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const load = async () => {
    try {
      setLoading(true);
      const res = await authService.getProfile();
      const data = res?.data || res;
      setForm({
        name: data?.name || currentUser?.name || '',
        email: data?.email || currentUser?.email || '',
        phone: data?.phone || currentUser?.phone || '',
      });
    } catch (e) {
      setForm({
        name: currentUser?.name || '',
        email: currentUser?.email || '',
        phone: currentUser?.phone || '',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
      };
      const res = await authService.updateProfile(payload);
      // If backend returns updated user, persist to local storage
      const updatedUser = res?.data || res?.user || null;
      if (updatedUser) {
        localStorage.setItem('user', JSON.stringify({ ...(currentUser || {}), ...updatedUser }));
      }
      toast.success('تم تحديث بيانات الحساب بنجاح');
      navigate('/company/settings');
    } catch (error) {
      const message = error?.response?.data?.message || 'فشل تحديث بيانات الحساب';
      toast.error(message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <Loader fullScreen={true} size="large" />;
  }

  return (
    <div className="employee-home-page" dir="rtl">
      <CompanyNav user={currentUser} />

      <div className="px-3 mb-3 mt-3">
        <div className="edit-hero">
          <div className="edit-hero-inner">
            <button
              className="settings-back-btn"
              onClick={() => navigate(-1)}
              style={{ background: 'transparent', border: 0 }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#343330" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
            <div className="edit-hero-badge">👤</div>
            <div className="edit-hero-text">
              <div className="edit-hero-title">تعديل حسابي</div>
              <div className="edit-hero-subtitle">حدّث معلوماتك الشخصية</div>
            </div>
          </div>
        </div>
      </div>

      <div className="all-jobs-section px-3 mb-5">
        {/* Profile summary card */}
        <div className="summary-card mb-3">
          <div className="summary-inner">
            <div className="avatar-initial large">
              {(form?.name || currentUser?.name || 'U').charAt(0).toUpperCase()}
            </div>
            <div className="summary-meta">
              <div className="summary-name">{form?.name || currentUser?.name || '—'}</div>
              <div className="summary-links">
                {(form?.email || currentUser?.email) && (
                  <a href={`mailto:${form?.email || currentUser?.email}`} className="link-soft">✉️ {form?.email || currentUser?.email}</a>
                )}
                {(form?.phone || currentUser?.phone) && (
                  <a href={`tel:${form?.phone || currentUser?.phone}`} className="link-soft" dir="ltr">📞 {form?.phone || currentUser?.phone}</a>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Edit card */}
        <div className="edit-card mb-4">
          <h4 className="section-title mb-3">بيانات الحساب</h4>
          <form onSubmit={handleSubmit}>
            <div className="grid-2">
              <div className="form-group-modern">
                <label className="form-label">الاسم</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="form-control-modern"
                  placeholder="اسم المستخدم"
                  required
                />
                <small className="form-hint">سيظهر هذا الاسم للآخرين داخل تطبيق الشركة</small>
              </div>
              <div className="form-group-modern">
                <label className="form-label">البريد الإلكتروني</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="form-control-modern"
                  placeholder="email@example.com"
                  required
                />
                <small className="form-hint">استخدم بريداً نشطاً لاستلام الإشعارات</small>
              </div>
              <div className="form-group-modern" dir="ltr">
                <label className="form-label">رقم الجوال</label>
                <PhoneInput
                  international
                  defaultCountry="EG"
                  value={form.phone}
                  onChange={(val) => setForm((prev) => ({ ...prev, phone: val }))}
                  className="phone-input-custom"
                />
                <small className="form-hint" dir="rtl">أدخل الرقم مع رمز الدولة (مثال: +20)</small>
              </div>
            </div>

            <div className="actions" style={{ display: 'flex', gap: 8 }}>
              <button type="submit" className="btn-primary-modern" disabled={saving}>
                {saving ? 'جارٍ الحفظ...' : 'حفظ التغييرات'}
              </button>
              <button type="button" className="btn-secondary-modern" onClick={() => navigate(-1)}>
                إلغاء
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Local styles for a creative, modern UI */}
      <style>
        {`
          .edit-hero {
            background: linear-gradient(135deg, rgba(96,143,211,0.15) 0%, rgba(74,123,196,0.15) 100%);
            border-radius: 18px;
            padding: 14px 16px;
          }
          .edit-hero-inner {
            display: flex;
            align-items: center;
            gap: 12px;
          }
          .edit-hero-badge {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            display: grid;
            place-items: center;
            background: linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%);
            color: #fff;
            font-size: 22px;
            box-shadow: 0 10px 20px rgba(76, 116, 179, 0.25);
          }
          .edit-hero-title {
            font-weight: 800;
            font-size: 1.1rem;
          }
          .edit-hero-subtitle {
            color: #475569;
            font-size: 0.9rem;
          }
          .summary-card {
            background: #ffffff;
            border-radius: 16px;
            border: 1px solid #eef2f7;
            box-shadow: 0 6px 20px rgba(0,0,0,0.04);
          }
          .summary-inner {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 14px 16px;
          }
          .avatar-initial {
            width: 36px;
            height: 36px;
            border-radius: 10px;
            display: grid;
            place-items: center;
            background: linear-gradient(135deg, #608fd3 0%, #4a7bc4 100%);
            color: #fff;
            font-weight: 800;
            box-shadow: 0 6px 14px rgba(76, 116, 179, 0.25);
          }
          .avatar-initial.large {
            width: 54px;
            height: 54px;
            border-radius: 14px;
            font-size: 1.1rem;
          }
          .summary-meta {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }
          .summary-name {
            font-weight: 800;
            color: #0f172a;
          }
          .summary-links {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
            align-items: center;
          }
          .link-soft { color: #334155; text-decoration: none; }
          .link-soft:hover { color: #111827; text-decoration: underline; }
          .edit-card {
            background: #ffffff;
            border-radius: 16px;
            padding: 18px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05);
            border: 1px solid #eef2f7;
          }
          .grid-2 {
            display: grid;
            grid-template-columns: 1fr;
            gap: 14px;
          }
          @media (min-width: 768px) {
            .grid-2 { grid-template-columns: 1fr 1fr; }
          }
          .form-group-modern {
            display: flex;
            flex-direction: column;
            gap: 6px;
          }
          .form-control-modern {
            width: 100%;
            border: 1px solid #e5e7eb;
            background: #fafafa;
            padding: 12px 14px;
            border-radius: 12px;
            outline: none;
            transition: box-shadow 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
          }
          .form-control-modern:focus {
            border-color: #4a7bc4;
            background: #fff;
            box-shadow: 0 0 0 4px rgba(74, 123, 196, 0.15);
          }
          .form-hint {
            color: #6b7280;
            font-size: 0.8rem;
          }
          .btn-secondary-modern {
            background: #ffffff;
            color: #374151;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 12px 16px;
            font-weight: 700;
            cursor: pointer;
          }
        `}
      </style>

      <CompanyBottomNavigation />
    </div>
  );
};

export default EditUserProfile;


